<template>
  <router-view />
</template>

<script>
export default {
  components: {},
};
</script>

<style lang="scss">
*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
  transition: all 0.3s;
}

html {
  box-sizing: border-box;
  font-size: 62.5%;
}

body {
  font-family: "Josefin Sans", sans-serif;
  font-size: 1.8rem;
  font-weight: 400;
}

ul {
  list-style: none;
}
</style>
